// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"0b9f19b7","761":"aba27e5e","787":"9c915ba3"}[chunkId] + ".chunk.js";
};